export interface CountryFilter {
  type: CountryFilterType;
  countries: string[];
}

export enum CountryFilterType {
  Include = 'include',
  Exclude = 'exclude',
}
